import { render } from "./StartUpCheck.vue?vue&type=template&id=676453ce&scoped=true&ts=true"
import script from "./StartUpCheck.vue?vue&type=script&lang=ts"
export * from "./StartUpCheck.vue?vue&type=script&lang=ts"

import "./StartUpCheck.vue?vue&type=style&index=0&id=676453ce&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676453ce"]])

export default __exports__